import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '../../assets/Images/icono-realtor.png'


const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]" }, null, -1)
const _hoisted_3 = {
  type: "button",
  class: "btn tw-flex tw-items-center tw-text-[#FFFFFF] tw-bg-[#00A0DA] tw-rounded-[15px] tw-pr-5 tw-pl-5 tw-pt-5 tw-pb-5 mt-3",
  style: {"margin-left":"2rem"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModalUsers"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_6 = {
  class: "modal fade modal-xl",
  id: "exampleModalUsers",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_7 = { class: "modal-dialog" }
const _hoisted_8 = { class: "modal-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_10 = { class: "modal-body" }
const _hoisted_11 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_12 = { class: "tw-flex tw-gap-3" }
const _hoisted_13 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Name", -1)
const _hoisted_15 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PhoneNumber", -1)
const _hoisted_17 = { class: "tw-w-full mb-3 tw-text-left" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Date", -1)
const _hoisted_19 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "NAME"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "E-MAIL"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PHONE NUMBER"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CREATION DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ACTION")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "5",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  class: "modal fade modal-xl",
  id: "exampleModal4858",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel4858",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_32 = { class: "modal-body" }
const _hoisted_33 = { class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_35 = { class: "tw-flex tw-justify-start gap-3 tw-w-full" }
const _hoisted_36 = {
  key: 0,
  class: "table-mlo w-100 bg-white p-3 rounded-4"
}
const _hoisted_37 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "CODE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "DATE"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SECTION"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCENARIO"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "WATCH SCENARIO")
  ])
], -1)
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye tw-text-[#00a0da] tw-text-[18px]" }, null, -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "4",
    class: "pt-5 pb-5"
  }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-center h-100 d-flex justify-content-center align-items-center",
      style: {"height":"250px"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, "Data not found")
    ])
  ])
], -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  class: "modal fade modal-xl",
  id: "exampleModalEscenario3",
  tabindex: "-1",
  "aria-labelledby": "exampleModalEscenario3",
  "aria-hidden": "true"
}
const _hoisted_47 = { class: "modal-dialog" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_50 = { class: "modal-body" }
const _hoisted_51 = { class: "tw-flex tw-justify-end tw-gap-[40px] tw-pr-7" }
const _hoisted_52 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-print tw-text-[#FFFFFF] tw-pr-2" }, null, -1)
const _hoisted_54 = { class: "tw-bg-[#00a0da] tw-px-5 tw-py-1 tw-rounded-full tw-text-[#ffffff]" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope tw-text-[#FFFFFF] tw-text-[18px] tw-pr-2" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("section", { slot: "pdf-content" }, null, -1)
const _hoisted_57 = {
  class: "tw-bg-white tw-w-full tw-rounded-bl-3xl tw-rounded-br-3xl tw-px-7 tw-py-5 tw-flex-col gap-y-",
  id: "printable-target"
}
const _hoisted_58 = { class: "tw-flex tw-flex-col tw-gap-5 tw-justify-between tw-fle tw-items-start tw-w-full tw-null tw-mb-4" }
const _hoisted_59 = {
  key: 0,
  class: "tw-flex tw-justify-start gap-3 tw-w-full"
}
const _hoisted_60 = { class: "table-mlo w-100 bg-white rounded-4" }
const _hoisted_61 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE LOAN ORIGINATOR")
  ])
], -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("td", null, "SCORE-CREDIT", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_67 = { class: "data" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", null, "NAME-MLO", -1)
const _hoisted_69 = { class: "data" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER-MLO", -1)
const _hoisted_71 = { class: "data" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL-MLO", -1)
const _hoisted_73 = { class: "data" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", null, "PROGRAM-MLO", -1)
const _hoisted_75 = { class: "data" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_77 = { class: "data" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-LOWER", -1)
const _hoisted_79 = { class: "data" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", null, "MINUMUM-DOWN-PAYMENT-HIGHER", -1)
const _hoisted_81 = { class: "data" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("td", null, "AVERAGE-PMI", -1)
const _hoisted_83 = { class: "data" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", null, "BACK-END-RATIO-D&I", -1)
const _hoisted_85 = { class: "data" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", null, "MAXIMUM-LOAN-NOT-JUMBO", -1)
const _hoisted_87 = { class: "table table-bordered border-0 mb-5 table-edit" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CUSTOMER")
  ])
], -1)
const _hoisted_89 = { class: "data" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", null, "NAME", -1)
const _hoisted_91 = { class: "data" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("td", null, "PHONE-NUMBER", -1)
const _hoisted_93 = { class: "data" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("td", null, "EMAIL", -1)
const _hoisted_95 = { class: "table table-bordered border-0 mb-3 table-edit" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "PROPERTY PRICE")
  ])
], -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("td", null, "PROPERTY-PRICE", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("td", null, "DOWN-PAYMENT", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("td", null, "LOAN-AMOUNT", -1)
const _hoisted_100 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE")
  ])
], -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", null, "INTEREST-RATE", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("td", null, "YEARS", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("td", null, "PMI-OR-MIP", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", null, "TOTAL-MONTHLY-PAYMENT $", -1)
const _hoisted_106 = {
  class: "modal fade",
  id: "exampleModalMessage",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_107 = { class: "modal-dialog" }
const _hoisted_108 = { class: "content-mensage modal-content tw-bg-[#E6E7E8]" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "boton-mensage modal-header tw-flex tw-items-center tw-outline-none tw-bg-[#00a0da] tw-border-[#00a0da] tw-bordered-[20px]" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title tw-text-white tw-text-xl",
    id: "exampleModalLabel"
  }, "New Message"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle tw-text-[25px] tw-text-white" })
  ])
], -1)
const _hoisted_110 = { class: "modal-body" }
const _hoisted_111 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "USER-EMAIL: ", -1)
const _hoisted_113 = { class: "tw-flex tw-items-center tw-justify-between tw-mt-[28px] tw-mb-[25px]" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", { class: "tw-w-[150px]" }, "SUBJECT: ", -1)
const _hoisted_115 = { class: "tw-mt-5 tw-w-full tw-flex tw-justify-center tw-items-center" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("div", { class: "tw-pl-5" }, null, -1)
const _hoisted_117 = { class: "modal-footer tw-flex tw-items-center tw-justify-between" }
const _hoisted_118 = { class: "tw-flex tw-justify-start tw-items-center" }
const _hoisted_119 = {
  key: 0,
  class: "btn-attach tw-bg-[#E6E7E8] tw-h-[40px] tw-font-bold tw-px-4 tw-rounded-full tw-text-xl"
}
const _hoisted_120 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip tw-text-gray-500" }, null, -1)
const _hoisted_121 = { class: "tw-flex tw-justify-end tw-items-center" }
const _hoisted_122 = ["disabled"]
const _hoisted_123 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-text-center tw-text-lg tw-text-[20px] tw-border-b-[2px] tw-border-[#b0b0b0] tw-pb-2" }, " MORTGAGE PAYMENT ", -1)
const _hoisted_125 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-5 tw-mt-3" }
const _hoisted_126 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExampleMortgageTittle",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("TITLE COMPANY")
], -1)
const _hoisted_128 = {
  class: "collapse",
  id: "collapseExampleMortgageTittle"
}
const _hoisted_129 = { class: "card card-body" }
const _hoisted_130 = { class: "tw-flex tw-justify-around" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_132 = ["onClick"]
const _hoisted_133 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("button", {
  class: "tw-bg-[#00a0da] tw-rounded-full tw-w-full tw-border-none tw-flex tw-justify-center tw-items-center tw-h-[40px] tw-gap-2 tw-text-white tw-font-light",
  "data-bs-toggle": "collapse",
  href: "#collapseExample8",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "collapseExample"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "tw-h-[20px] tw-w-[20px] tw-grayscale-0 tw-invert tw-brightness-0",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("INSPECTOR")
], -1)
const _hoisted_135 = {
  class: "collapse",
  id: "collapseExample8"
}
const _hoisted_136 = { class: "card card-body" }
const _hoisted_137 = { class: "tw-flex tw-justify-around" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("button", { class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]" }, "GET IT", -1)
const _hoisted_140 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE LOAN ORIGINATOR", -1)
const _hoisted_142 = { class: "tw-px-4" }
const _hoisted_143 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_144 = { class: "tw-w-full" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROPERTY", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROPERTY", -1)
const _hoisted_147 = ["value"]
const _hoisted_148 = { class: "tw-w-full" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "SCORE CREDIT", -1)
const _hoisted_150 = { class: "tw-w-full" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PROGRAM", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT PROGRAM", -1)
const _hoisted_153 = ["value"]
const _hoisted_154 = { class: "tw-w-full" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "YEARS", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("option", { value: null }, "SELECT YEAR", -1)
const _hoisted_157 = ["value"]
const _hoisted_158 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-5" }
const _hoisted_159 = ["disabled"]
const _hoisted_160 = {
  class: "modal fade",
  id: "exampleModalMlo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_161 = { class: "modal-dialog modal-xl" }
const _hoisted_162 = { class: "modal-content" }
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close custom-close-button",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_164 = { class: "modal-body" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Select an option...")
], -1)
const _hoisted_166 = { class: "modal-mlo d-flex tw-justify-center tw-gap-[30px] tw-mb-[30px]" }
const _hoisted_167 = ["onClick"]
const _hoisted_168 = { class: "modal-mlo d-flex justify-content-around tw-mb-[20px]" }
const _hoisted_169 = { class: "tw-text-[#00a0da] tw-text-[20px]" }
const _hoisted_170 = { class: "modal-mlo d-flex justify-content-around mb-2" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("span", null, "USERNAME", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("span", null, "LASTNAME", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("span", null, "PHONE-NUMBER", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("span", null, "EMAIL", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_179 = { key: 0 }
const _hoisted_180 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_181 = { class: "mlo-tables d-flex flex-column px-4" }
const _hoisted_182 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_183 = { class: "w-50" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "15 YEARS")
], -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_186 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_188 = { class: "data" }
const _hoisted_189 = ["onUpdate:modelValue"]
const _hoisted_190 = ["onUpdate:modelValue"]
const _hoisted_191 = ["onUpdate:modelValue"]
const _hoisted_192 = ["onUpdate:modelValue"]
const _hoisted_193 = ["onUpdate:modelValue"]
const _hoisted_194 = ["onUpdate:modelValue"]
const _hoisted_195 = { class: "w-50" }
const _hoisted_196 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "30 YEARS")
], -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_198 = { class: "pb-3" }
const _hoisted_199 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_201 = { class: "data" }
const _hoisted_202 = ["onUpdate:modelValue"]
const _hoisted_203 = ["onUpdate:modelValue"]
const _hoisted_204 = ["onUpdate:modelValue"]
const _hoisted_205 = ["onUpdate:modelValue"]
const _hoisted_206 = ["onUpdate:modelValue"]
const _hoisted_207 = ["onUpdate:modelValue"]
const _hoisted_208 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_209 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_210 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_211 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "tw-border-b-0"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "LOWER THAN"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "HIGHER THAN")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT LOWER THAN"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT HIGHER THAN "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %")
  ])
], -1)
const _hoisted_212 = { class: "text-left" }
const _hoisted_213 = ["onUpdate:modelValue"]
const _hoisted_214 = ["onUpdate:modelValue"]
const _hoisted_215 = ["onUpdate:modelValue"]
const _hoisted_216 = ["onUpdate:modelValue"]
const _hoisted_217 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_218 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_219 = ["onUpdate:modelValue"]
const _hoisted_220 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_221 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "tw-border-b-0"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE INSURANCE ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MIP %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PMI %")
  ])
], -1)
const _hoisted_223 = { class: "text-left" }
const _hoisted_224 = ["onUpdate:modelValue"]
const _hoisted_225 = ["onUpdate:modelValue"]
const _hoisted_226 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_228 = ["onUpdate:modelValue"]
const _hoisted_229 = { class: "d-flex justify-content-center mt-4 pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_230 = { class: "tw-flex tw-justify-between pt-4 gap-5" }
const _hoisted_231 = { class: "tw-w-1/2" }
const _hoisted_232 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "BACK END RATIO D&1 % ")
  ])
], -1)
const _hoisted_234 = { class: "data" }
const _hoisted_235 = { class: "text-left" }
const _hoisted_236 = { class: "d-flex justify-content-between" }
const _hoisted_237 = ["onUpdate:modelValue"]
const _hoisted_238 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_239 = {
  key: 0,
  class: "table table-bordered border-0 mb-0 table-edit tw-mt-8"
}
const _hoisted_240 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FAMILY HOUSING EXPENSES ")
  ])
], -1)
const _hoisted_241 = { key: 0 }
const _hoisted_242 = { class: "data" }
const _hoisted_243 = { colspan: "2" }
const _hoisted_244 = ["onUpdate:modelValue"]
const _hoisted_245 = { class: "tw-w-1/2" }
const _hoisted_246 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_247 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PROGRAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MAXIMUM LOAN AMOUNT $ ")
  ])
], -1)
const _hoisted_248 = { class: "data" }
const _hoisted_249 = { class: "text-left" }
const _hoisted_250 = { class: "d-flex justify-content-between" }
const _hoisted_251 = ["onUpdate:modelValue"]
const _hoisted_252 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_253 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_254 = ["onUpdate:modelValue"]
const _hoisted_255 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_256 = { class: "mlo-tables d-flex flex-column px-4" }
const _hoisted_257 = { class: "pt-3 pb-3" }
const _hoisted_258 = ["onUpdate:modelValue"]
const _hoisted_259 = { class: "d-flex justify-content-between pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_260 = { class: "w-50" }
const _hoisted_261 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "15 YEARS")
], -1)
const _hoisted_262 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_263 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_264 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_265 = { class: "data" }
const _hoisted_266 = ["onUpdate:modelValue"]
const _hoisted_267 = ["onUpdate:modelValue"]
const _hoisted_268 = ["onUpdate:modelValue"]
const _hoisted_269 = ["onUpdate:modelValue"]
const _hoisted_270 = ["onUpdate:modelValue"]
const _hoisted_271 = ["onUpdate:modelValue"]
const _hoisted_272 = { class: "w-50" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("div", { class: "mlo-tables__contenido-15year__tittle text-center mt-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Average Fix Interest Rates"),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "30 YEARS")
], -1)
const _hoisted_274 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_275 = { class: "pb-3" }
const _hoisted_276 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_277 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FHA"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "CONVENTIONAL "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "VA")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "%")
  ])
], -1)
const _hoisted_278 = { class: "data" }
const _hoisted_279 = ["onUpdate:modelValue"]
const _hoisted_280 = ["onUpdate:modelValue"]
const _hoisted_281 = ["onUpdate:modelValue"]
const _hoisted_282 = ["onUpdate:modelValue"]
const _hoisted_283 = ["onUpdate:modelValue"]
const _hoisted_284 = ["onUpdate:modelValue"]
const _hoisted_285 = { class: "d-flex justify-content-between gap-4 mt-4" }
const _hoisted_286 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_287 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_288 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "tw-border-b-0"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "LOWER THAN"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "HIGHER THAN")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT LOWER THAN"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "SCORE CREDIT HIGHER THAN "),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MINIMMUM DOWN PAYMENT %")
  ])
], -1)
const _hoisted_289 = { class: "text-left" }
const _hoisted_290 = ["onUpdate:modelValue"]
const _hoisted_291 = ["onUpdate:modelValue"]
const _hoisted_292 = ["onUpdate:modelValue"]
const _hoisted_293 = ["onUpdate:modelValue"]
const _hoisted_294 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_295 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_296 = ["onUpdate:modelValue"]
const _hoisted_297 = { class: "w-50 bg-white p-3 rounded-4" }
const _hoisted_298 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_299 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "tw-border-b-0"
    }),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "MORTGAGE INSURANCE ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MIP %"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PMI %")
  ])
], -1)
const _hoisted_300 = { class: "text-left" }
const _hoisted_301 = ["onUpdate:modelValue"]
const _hoisted_302 = ["onUpdate:modelValue"]
const _hoisted_303 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_305 = ["onUpdate:modelValue"]
const _hoisted_306 = { class: "d-flex justify-content-center mt-4 pb-4 px-4 gap-5 bg-white rounded-4" }
const _hoisted_307 = { class: "tw-flex tw-justify-between pt-4 gap-5" }
const _hoisted_308 = { class: "tw-w-1/2" }
const _hoisted_309 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_310 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "BACK END RATIO D&1 % ")
  ])
], -1)
const _hoisted_311 = { class: "data" }
const _hoisted_312 = { class: "text-left" }
const _hoisted_313 = { class: "d-flex justify-content-between" }
const _hoisted_314 = ["onUpdate:modelValue"]
const _hoisted_315 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_316 = {
  key: 0,
  class: "table table-bordered border-0 mb-0 table-edit tw-mt-8"
}
const _hoisted_317 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FAMILY HOUSING EXPENSES")
  ])
], -1)
const _hoisted_318 = { key: 0 }
const _hoisted_319 = { class: "data" }
const _hoisted_320 = { colspan: "2" }
const _hoisted_321 = ["onUpdate:modelValue"]
const _hoisted_322 = { class: "tw-w-1/2" }
const _hoisted_323 = { class: "table table-bordered border-0 mb-0 table-edit" }
const _hoisted_324 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "PROGRAM"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "MAXIMUM LOAN AMOUNT $ ")
  ])
], -1)
const _hoisted_325 = { class: "data" }
const _hoisted_326 = { class: "text-left" }
const _hoisted_327 = { class: "d-flex justify-content-between" }
const _hoisted_328 = ["onUpdate:modelValue"]
const _hoisted_329 = { class: "table table-bordered border-0 mb-0 table-edit mt-4" }
const _hoisted_330 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "COMMENTARIES")
  ])
], -1)
const _hoisted_331 = ["onUpdate:modelValue"]
const _hoisted_332 = { class: "modal-footer tw-justify-center" }
const _hoisted_333 = { class: "tw-mt-4 tw-mb-12" }
const _hoisted_334 = { class: "tw-w-full table-edit" }
const _hoisted_335 = ["colspan"]
const _hoisted_336 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-justify-center tw-text-white tw-text-base tw-py-2" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-[13px]" }, "PERSONAL DATA")
], -1)
const _hoisted_337 = [
  _hoisted_336
]
const _hoisted_338 = { key: 0 }
const _hoisted_339 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_340 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " NAME ", -1)
const _hoisted_341 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_342 = { key: 0 }
const _hoisted_343 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_344 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PHONE NUMBER", -1)
const _hoisted_345 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_346 = { key: 0 }
const _hoisted_347 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_348 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " EMAIL", -1)
const _hoisted_349 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_350 = { key: 0 }
const _hoisted_351 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_352 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_353 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_354 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_355 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTERES RATE", -1)
const _hoisted_356 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_357 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_358 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MINIMUM DOWN PAYMENT", -1)
const _hoisted_359 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_360 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_361 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " AVERAGE PMI", -1)
const _hoisted_362 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_363 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_364 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BACK END RATIO D&I", -1)
const _hoisted_365 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_366 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_367 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MAXIMUM LOAN NOT JUMBO", -1)
const _hoisted_368 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_369 = { class: "tw-w-full table-edit tw-shadow-none tw-border-none tw-mt-2" }
const _hoisted_370 = { class: "tw-[&>td]:border-r-0" }
const _hoisted_371 = /*#__PURE__*/_createElementVNode("td", { class: "tw-border-none" }, null, -1)
const _hoisted_372 = { class: "tw-border-none tw-px-4" }
const _hoisted_373 = ["onClick"]
const _hoisted_374 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden tw-pb-[30px]" }
const _hoisted_375 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " CUSTOMER", -1)
const _hoisted_376 = { class: "tw-px-4" }
const _hoisted_377 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-border tw-border-b-[#545454] tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-pb-1 tw-mt-7 tw-text-left" }, " PERSONAL DATA", -1)
const _hoisted_378 = { class: "tw-flex tw-justify-between tw-items-center tw-mt-3 tw-gap-5 tw-text-left" }
const _hoisted_379 = { class: "tw-w-full" }
const _hoisted_380 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "NAME", -1)
const _hoisted_381 = { class: "tw-w-full" }
const _hoisted_382 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "PHONE NUMBER", -1)
const _hoisted_383 = { class: "tw-w-full" }
const _hoisted_384 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "EMAIL", -1)
const _hoisted_385 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_386 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " PROPERTY PRICE", -1)
const _hoisted_387 = { class: "tw-px-4" }
const _hoisted_388 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_389 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_390 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE", -1)
const _hoisted_391 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_392 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_393 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT", -1)
const _hoisted_394 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_395 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_396 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT", -1)
const _hoisted_397 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_398 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-rounded-xl tw-overflow-hidden" }
const _hoisted_399 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold tw-text-left" }, " MORTGAGE", -1)
const _hoisted_400 = { class: "tw-px-4" }
const _hoisted_401 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_402 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_403 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE", -1)
const _hoisted_404 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_405 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_406 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " YEARS", -1)
const _hoisted_407 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_408 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_409 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_410 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_411 = { class: "tw-flex justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-justify-center" }
const _hoisted_412 = { class: "tw-flex tw-justify-center" }
const _hoisted_413 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_414 = { class: "tw-flex tw-justify-end" }
const _hoisted_415 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_416 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL ESTIMATED MONTHLY PAYMENT $ ", -1)
const _hoisted_417 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }
const _hoisted_418 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_ResidentialView = _resolveComponent("ResidentialView")!
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_VueNumberFormat = _resolveComponent("VueNumberFormat")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["tw-fixed tw-top-0 tw-left-0", { 'tw-w-full tw-h-full': _ctx.loaderConfig.isLoading }])
    }, [
      _createVNode(_component_loading, {
        active: _ctx.loaderConfig.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loaderConfig.isLoading) = $event)),
        "can-cancel": false,
        loader: 'dots',
        "is-full-page": !_ctx.loaderConfig.fullPage
      }, null, 8, ["active", "is-full-page"])
    ], 2),
    _createVNode(_component_TopBar, {
      helpBar: true,
      helpDescription: "Video tutorial for the use of the ''MORTGAGE PAYMENT''",
      helpVideo: "https://www.realtortools.org/media/VideoMortgagePayment.mp4"
    }),
    _createElementVNode("div", null, [
      _createVNode(_component_ResidentialView, { header: false })
    ]),
    _hoisted_2,
    _createElementVNode("button", _hoisted_3, [
      _createElementVNode("img", {
        class: "tw-w-[40px] tw-mr-3",
        src: require('@/assets/Images/iconos-02.png'),
        alt: ""
      }, null, 8, _hoisted_4),
      _createTextVNode(" RECORD ")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (_ctx.scenario.users)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.scenario.users.name) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          name: "",
                          id: "",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.scenario.users.phonenumber) = $event)),
                          class: "tw-w-full tw-outline-none tw-h-[38px] tw-border tw-border-[#dddddd] tw-rounded-lg tw-overflow-hidden tw-px-4"
                        }, null, 512), [
                          [_vModelText, _ctx.params.scenario.users.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createVNode(_component_datepicker, {
                          "auto-apply": "",
                          class: "w-100",
                          range: "",
                          modelValue: _ctx.configDatePicker.date,
                          "onUpdate:modelValue": [
                            _cache[3] || (_cache[3] = ($event: any) => ((_ctx.configDatePicker.date) = $event)),
                            _ctx.changeDate
                          ],
                          placeholder: "Enter date range..."
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getScenarioUsers())),
                      class: "mb-3 tw-bg-[#00a0da] tw-text-white tw-h-[35px] tw-font-bold tw-w-[150px] tw-rounded-full tw-text-[18px]"
                    }, "Filter"),
                    _createElementVNode("table", _hoisted_19, [
                      _hoisted_20,
                      (_ctx.scenario.users.results && _ctx.scenario.users.results.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.users.results, (user) => {
                              return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, _toDisplayString(user.user_name), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_email), 1),
                                _createElementVNode("td", null, _toDisplayString(user.user_phonenumber), 1),
                                _createElementVNode("td", null, _toDisplayString(user.create_date), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("a", {
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#exampleModal4858",
                                    href: "#",
                                    onClick: ($event: any) => (_ctx.loadScenarios(user))
                                  }, _hoisted_24, 8, _hoisted_22)
                                ])
                              ]))
                            }), 256))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_25, _hoisted_27))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    (_ctx.scenario.userScenarios)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createElementVNode("table", _hoisted_37, [
                            _hoisted_38,
                            (_ctx.scenario.userScenarios.results && _ctx.scenario.userScenarios.results.length > 0)
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenario.userScenarios.results, (userscenario) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                      _createElementVNode("td", null, _toDisplayString(userscenario.code), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.date), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type), 1),
                                      _createElementVNode("td", null, _toDisplayString(userscenario.type_name), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("a", {
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#exampleModalEscenario3",
                                          href: "#",
                                          onClick: ($event: any) => (_ctx.loadScenario(userscenario))
                                        }, _hoisted_42, 8, _hoisted_40)
                                      ])
                                    ]))
                                  }), 256))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_43, _hoisted_45))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printScenario())),
                    class: "block"
                  }, [
                    _hoisted_53,
                    _createTextVNode("PRINT")
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.generateMail()))
                  }, [
                    _hoisted_55,
                    _createTextVNode("SEND")
                  ]),
                  _createVNode(_component_vue3_html2pdf, {
                    "show-layout": false,
                    "float-layout": true,
                    "enable-download": false,
                    "preview-modal": false,
                    "pdf-quality": 2,
                    "pdf-format": "a4",
                    "pdf-content-width": "800px",
                    "manual-pagination": true,
                    onBeforeDownload: _cache[7] || (_cache[7] = ($event: any) => (_ctx.beforeFileGenerated($event))),
                    ref: "html2Pdf"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_56
                    ]),
                    _: 1
                  }, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("div", _hoisted_58, [
                  (_ctx.scenario && _ctx.scenario.scenarioData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                          _createElementVNode("table", _hoisted_61, [
                            _hoisted_62,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_63,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedProperty.name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_64,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.score), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_65,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.program_name), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_66,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.years), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_67, [
                                _hoisted_68,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.username), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_69, [
                                _hoisted_70,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.phonenumber), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.email), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_73, [
                                _hoisted_74,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.program_name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.interes_rate), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_77, [
                                _hoisted_78,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.minimum_down_paymentlower), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.minimum_down_paymenthigher), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_81, [
                                _hoisted_82,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.average_mip_pmi), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_83, [
                                _hoisted_84,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.backend_ratio), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.maximum_loan), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_87, [
                            _hoisted_88,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", _hoisted_89, [
                                _hoisted_90,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_name), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_91, [
                                _hoisted_92,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_phonenumber), 1)
                              ]),
                              _createElementVNode("tr", _hoisted_93, [
                                _hoisted_94,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.user.user_email), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_95, [
                            _hoisted_96,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_97,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.property_price.propertyPrice), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_98,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.property_price.downPayment), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_99,
                                _createElementVNode("td", null, "$" + _toDisplayString(_ctx.scenario.scenarioData.property_price.loanAmount), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("table", _hoisted_100, [
                            _hoisted_101,
                            _createElementVNode("tbody", null, [
                              _createElementVNode("tr", null, [
                                _hoisted_102,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.personal_data.selectedUser.interes_rate), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_103,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.mortgage.years), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_104,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.property_price.pmi), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_105,
                                _createElementVNode("td", null, _toDisplayString(_ctx.scenario.scenarioData.property_price.totalMonthly), 1)
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_106, [
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("div", _hoisted_111, [
                _hoisted_112,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.scenarioMail.email) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_113, [
                _hoisted_114,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.scenarioMail.subject) = $event)),
                  class: "tw-w-full tw-h-[32px]",
                  style: {"padding-left":"10px"}
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.subject]
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _withDirectives(_createElementVNode("textarea", {
                  name: "",
                  id: "",
                  cols: "53",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.scenarioMail.message) = $event)),
                  rows: "9"
                }, null, 512), [
                  [_vModelText, _ctx.scenarioMail.message]
                ])
              ])
            ]),
            _hoisted_116,
            _createElementVNode("div", _hoisted_117, [
              _createElementVNode("div", _hoisted_118, [
                (_ctx.scenarioMail.file)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_119, [
                      _hoisted_120,
                      _createTextVNode(" " + _toDisplayString(_ctx.scenarioMail.file.name), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_121, [
                _createElementVNode("button", {
                  "data-bs-dismiss": "modal",
                  class: "tw-bg-[#78c18a] disabled:tw-bg-[#cfcfcf] disabled:tw-text-white tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl",
                  disabled: _ctx.v$.scenarioMail.$invalid,
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendScenarioMail && _ctx.sendScenarioMail(...args)))
                }, "SEND MESSAGE", 8, _hoisted_122)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_123, [
        _hoisted_124,
        _createElementVNode("div", _hoisted_125, [
          _createElementVNode("div", _hoisted_126, [
            _hoisted_127,
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTitleCompanies, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.companyname), 1),
                      _createTextVNode(),
                      _hoisted_131,
                      _createElementVNode("button", {
                        class: "tw-bg-[#00a0da] tw-px-11 tw-mt-2 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[180px]",
                        onClick: ($event: any) => (_ctx.getItTitleCompany(user))
                      }, "GET IT", 8, _hoisted_132)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_133, [
            _hoisted_134,
            _createElementVNode("div", _hoisted_135, [
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", _hoisted_137, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listInspectors, (user) => {
                    return (_openBlock(), _createElementBlock("div", null, [
                      _createElementVNode("span", null, _toDisplayString(user.username + " " + user.lastname), 1),
                      _createTextVNode(),
                      _hoisted_138,
                      _hoisted_139
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_140, [
          _hoisted_141,
          _createElementVNode("div", _hoisted_142, [
            _createElementVNode("div", _hoisted_143, [
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters.property) = $event))
                }, [
                  _hoisted_146,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTableProperties, (tabletype) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: tabletype.id
                    }, _toDisplayString(tabletype.name), 9, _hoisted_147))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.property]
                ])
              ]),
              _createElementVNode("div", _hoisted_148, [
                _hoisted_149,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.score) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.filters.score]
                ])
              ]),
              _createElementVNode("div", _hoisted_150, [
                _hoisted_151,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filters.program) = $event))
                }, [
                  _hoisted_152,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPrograms, (program) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: program.id
                    }, _toDisplayString(program.name), 9, _hoisted_153))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.program]
                ])
              ]),
              _createElementVNode("div", _hoisted_154, [
                _hoisted_155,
                _withDirectives(_createElementVNode("select", {
                  name: "",
                  id: "",
                  class: "tw-w-full tw-border-[#b6b6b6] tw-outline-none tw-h-[45px] tw-border tw-rounded-lg tw-overflow-hidden tw-px-1 tw-cursor-pointer tw-mt-2",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.year) = $event))
                }, [
                  _hoisted_156,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listYears, (year) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: year.id
                    }, _toDisplayString(year.name), 9, _hoisted_157))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.filters.year]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_158, [
              _createElementVNode("button", {
                class: "tw-bg-[#00a0da] disabled:tw-bg-[#ccc] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-w-[200px]",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.filterTable && _ctx.filterTable(...args))),
                disabled: _ctx.listUserSections.length == 0
              }, "RUN", 8, _hoisted_159)
            ]),
            _createElementVNode("div", _hoisted_160, [
              _createElementVNode("div", _hoisted_161, [
                _createElementVNode("div", _hoisted_162, [
                  _hoisted_163,
                  _createElementVNode("div", _hoisted_164, [
                    _hoisted_165,
                    _createElementVNode("div", _hoisted_166, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableTypesMLO, (tabletype) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("button", {
                            class: "tw-bg-[#00a0da] tw-rounded-full tw-text-white px-3",
                            onClick: ($event: any) => (_ctx.changeTableType(tabletype.key))
                          }, _toDisplayString(tabletype.name.toUpperCase()), 9, _hoisted_167)
                        ]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_168, [
                      _createElementVNode("span", _hoisted_169, _toDisplayString(_ctx.titleTable.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", _hoisted_170, [
                      _createElementVNode("div", null, [
                        _hoisted_171,
                        _createTextVNode(),
                        _hoisted_172,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.userMLO.username) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.userMLO.username]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_173,
                        _createTextVNode(),
                        _hoisted_174,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userMLO.lastname) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.userMLO.lastname]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_175,
                        _createTextVNode(),
                        _hoisted_176,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userMLO.phonenumber) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.userMLO.phonenumber]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_177,
                        _createTextVNode(),
                        _hoisted_178,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userMLO.email) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.userMLO.email]
                        ])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableTypesMLO, (tabletype) => {
                      return (_openBlock(), _createElementBlock("div", null, [
                        (tabletype.visible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_179, [
                              (_ctx.tables && _ctx.tables.length > 0 && tabletype.key == 'mlo_primary')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                    _createElementVNode("div", _hoisted_181, [
                                      _createElementVNode("div", _hoisted_182, [
                                        _createElementVNode("div", _hoisted_183, [
                                          _hoisted_184,
                                          _hoisted_185,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("table", _hoisted_186, [
                                              _hoisted_187,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[0].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_188, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                                      }, null, 8, _hoisted_189), [
                                                        [_vModelText, t.fha_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                                      }, null, 8, _hoisted_190), [
                                                        [_vModelText, t.fha_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                                      }, null, 8, _hoisted_191), [
                                                        [_vModelText, t.coventional_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                                      }, null, 8, _hoisted_192), [
                                                        [_vModelText, t.coventional_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                                      }, null, 8, _hoisted_193), [
                                                        [_vModelText, t.va_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                                      }, null, 8, _hoisted_194), [
                                                        [_vModelText, t.va_percent]
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_195, [
                                          _hoisted_196,
                                          _hoisted_197,
                                          _createElementVNode("div", _hoisted_198, [
                                            _createElementVNode("table", _hoisted_199, [
                                              _hoisted_200,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[1].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_201, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                                      }, null, 8, _hoisted_202), [
                                                        [_vModelText, t.fha_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                                      }, null, 8, _hoisted_203), [
                                                        [_vModelText, t.fha_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                                      }, null, 8, _hoisted_204), [
                                                        [_vModelText, t.coventional_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                                      }, null, 8, _hoisted_205), [
                                                        [_vModelText, t.coventional_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                                      }, null, 8, _hoisted_206), [
                                                        [_vModelText, t.va_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                                      }, null, 8, _hoisted_207), [
                                                        [_vModelText, t.va_percent]
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_208, [
                                        _createElementVNode("div", _hoisted_209, [
                                          _createElementVNode("table", _hoisted_210, [
                                            _hoisted_211,
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[2].data, (t) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                  _createElementVNode("td", _hoisted_212, _toDisplayString(t.table_name), 1),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_store_credit_lower_than) = $event)
                                                    }, null, 8, _hoisted_213), [
                                                      [_vModelText, t.table_store_credit_lower_than]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_minimmum_down_payment) = $event)
                                                    }, null, 8, _hoisted_214), [
                                                      [_vModelText, t.table_minimmum_down_payment]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than) = $event)
                                                    }, null, 8, _hoisted_215), [
                                                      [_vModelText, t.table_score_credit_higher_than]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than_b) = $event)
                                                    }, null, 8, _hoisted_216), [
                                                      [_vModelText, t.table_score_credit_higher_than_b]
                                                    ])
                                                  ])
                                                ]))
                                              }), 256))
                                            ])
                                          ]),
                                          _createElementVNode("table", _hoisted_217, [
                                            _hoisted_218,
                                            _createElementVNode("tbody", null, [
                                              _createElementVNode("tr", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[3].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("td", null, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                      name: "",
                                                      id: "",
                                                      cols: "30",
                                                      rows: "5",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                    }, null, 8, _hoisted_219), [
                                                      [_vModelText, t.table_comments]
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_220, [
                                          _createElementVNode("table", _hoisted_221, [
                                            _hoisted_222,
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[4].data, (t) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                  _createElementVNode("td", _hoisted_223, _toDisplayString(t.table_name), 1),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_mip) = $event)
                                                    }, null, 8, _hoisted_224), [
                                                      [_vModelText, t.table_mip]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_pmi) = $event)
                                                    }, null, 8, _hoisted_225), [
                                                      [_vModelText, t.table_pmi]
                                                    ])
                                                  ])
                                                ]))
                                              }), 256))
                                            ])
                                          ]),
                                          _createElementVNode("table", _hoisted_226, [
                                            _hoisted_227,
                                            _createElementVNode("tbody", null, [
                                              _createElementVNode("tr", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[5].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("td", null, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                      name: "",
                                                      id: "",
                                                      cols: "30",
                                                      rows: "5",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                    }, null, 8, _hoisted_228), [
                                                      [_vModelText, t.table_comments]
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_229, [
                                        _createElementVNode("div", _hoisted_230, [
                                          _createElementVNode("div", _hoisted_231, [
                                            _createElementVNode("table", _hoisted_232, [
                                              _hoisted_233,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[6].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_234, [
                                                    _createElementVNode("td", _hoisted_235, _toDisplayString(t.table_name), 1),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_236, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "number",
                                                          "onUpdate:modelValue": ($event: any) => ((t.table_backend_ratio) = $event)
                                                        }, null, 8, _hoisted_237), [
                                                          [_vModelText, t.table_backend_ratio]
                                                        ]),
                                                        _hoisted_238
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ]),
                                            (_ctx.$route.query.table != 'foreign' || _ctx.$route.query.table)
                                              ? (_openBlock(), _createElementBlock("table", _hoisted_239, [
                                                  _hoisted_240,
                                                  (_ctx.tables && _ctx.tables[10])
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_241, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[10].data, (t) => {
                                                          return (_openBlock(), _createElementBlock("tr", _hoisted_242, [
                                                            _createElementVNode("td", _hoisted_243, [
                                                              _createElementVNode("div", null, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                  type: "text",
                                                                  "onUpdate:modelValue": ($event: any) => ((t.table_text) = $event)
                                                                }, null, 8, _hoisted_244), [
                                                                  [_vModelText, t.table_text]
                                                                ])
                                                              ])
                                                            ])
                                                          ]))
                                                        }), 256))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_245, [
                                            _createElementVNode("table", _hoisted_246, [
                                              _hoisted_247,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[8].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_248, [
                                                    _createElementVNode("td", _hoisted_249, _toDisplayString(t.table_name), 1),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_250, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "number",
                                                          "onUpdate:modelValue": ($event: any) => ((t.table_input_mla) = $event)
                                                        }, null, 8, _hoisted_251), [
                                                          [_vModelText, t.table_input_mla]
                                                        ])
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ]),
                                            _createElementVNode("table", _hoisted_252, [
                                              _hoisted_253,
                                              _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tables[9].data, (t) => {
                                                    return (_openBlock(), _createElementBlock("td", null, [
                                                      _withDirectives(_createElementVNode("textarea", {
                                                        name: "",
                                                        id: "",
                                                        cols: "30",
                                                        rows: "5",
                                                        "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                      }, null, 8, _hoisted_254), [
                                                        [_vModelText, t.table_comments]
                                                      ])
                                                    ]))
                                                  }), 256))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (tabletype.key != 'mlo_primary' && tabletype.tables && tabletype.tables.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_255, [
                                    _createElementVNode("div", _hoisted_256, [
                                      (tabletype.key == 'mlo_special')
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(tabletype.tables[7].data, (t) => {
                                            return (_openBlock(), _createElementBlock("div", _hoisted_257, [
                                              _withDirectives(_createElementVNode("input", {
                                                placeholder: "Enter Special Program Name",
                                                class: "input-tittle",
                                                type: "text",
                                                "onUpdate:modelValue": ($event: any) => ((t.input_mlo) = $event)
                                              }, null, 8, _hoisted_258), [
                                                [_vModelText, t.input_mlo]
                                              ])
                                            ]))
                                          }), 256))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_259, [
                                        _createElementVNode("div", _hoisted_260, [
                                          _hoisted_261,
                                          _hoisted_262,
                                          _createElementVNode("div", null, [
                                            _createElementVNode("table", _hoisted_263, [
                                              _hoisted_264,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[0].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_265, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                                      }, null, 8, _hoisted_266), [
                                                        [_vModelText, t.fha_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                                      }, null, 8, _hoisted_267), [
                                                        [_vModelText, t.fha_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                                      }, null, 8, _hoisted_268), [
                                                        [_vModelText, t.coventional_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                                      }, null, 8, _hoisted_269), [
                                                        [_vModelText, t.coventional_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                                      }, null, 8, _hoisted_270), [
                                                        [_vModelText, t.va_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                                      }, null, 8, _hoisted_271), [
                                                        [_vModelText, t.va_percent]
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_272, [
                                          _hoisted_273,
                                          _hoisted_274,
                                          _createElementVNode("div", _hoisted_275, [
                                            _createElementVNode("table", _hoisted_276, [
                                              _hoisted_277,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[1].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_278, [
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_credit) = $event)
                                                      }, null, 8, _hoisted_279), [
                                                        [_vModelText, t.fha_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.fha_percent) = $event)
                                                      }, null, 8, _hoisted_280), [
                                                        [_vModelText, t.fha_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_credit) = $event)
                                                      }, null, 8, _hoisted_281), [
                                                        [_vModelText, t.coventional_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.coventional_percent) = $event)
                                                      }, null, 8, _hoisted_282), [
                                                        [_vModelText, t.coventional_percent]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "text",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_credit) = $event)
                                                      }, null, 8, _hoisted_283), [
                                                        [_vModelText, t.va_credit]
                                                      ])
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _withDirectives(_createElementVNode("input", {
                                                        type: "number",
                                                        "onUpdate:modelValue": ($event: any) => ((t.va_percent) = $event)
                                                      }, null, 8, _hoisted_284), [
                                                        [_vModelText, t.va_percent]
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_285, [
                                        _createElementVNode("div", _hoisted_286, [
                                          _createElementVNode("table", _hoisted_287, [
                                            _hoisted_288,
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[2].data, (t) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                  _createElementVNode("td", _hoisted_289, _toDisplayString(t.table_name), 1),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_store_credit_lower_than) = $event)
                                                    }, null, 8, _hoisted_290), [
                                                      [_vModelText, t.table_store_credit_lower_than]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_minimmum_down_payment) = $event)
                                                    }, null, 8, _hoisted_291), [
                                                      [_vModelText, t.table_minimmum_down_payment]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than) = $event)
                                                    }, null, 8, _hoisted_292), [
                                                      [_vModelText, t.table_score_credit_higher_than]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_score_credit_higher_than_b) = $event)
                                                    }, null, 8, _hoisted_293), [
                                                      [_vModelText, t.table_score_credit_higher_than_b]
                                                    ])
                                                  ])
                                                ]))
                                              }), 256))
                                            ])
                                          ]),
                                          _createElementVNode("table", _hoisted_294, [
                                            _hoisted_295,
                                            _createElementVNode("tbody", null, [
                                              _createElementVNode("tr", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[3].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("td", null, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                      name: "",
                                                      id: "",
                                                      cols: "30",
                                                      rows: "5",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                    }, null, 8, _hoisted_296), [
                                                      [_vModelText, t.table_comments]
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_297, [
                                          _createElementVNode("table", _hoisted_298, [
                                            _hoisted_299,
                                            _createElementVNode("tbody", null, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[4].data, (t) => {
                                                return (_openBlock(), _createElementBlock("tr", null, [
                                                  _createElementVNode("td", _hoisted_300, _toDisplayString(t.table_name), 1),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_mip) = $event)
                                                    }, null, 8, _hoisted_301), [
                                                      [_vModelText, t.table_mip]
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "number",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_pmi) = $event)
                                                    }, null, 8, _hoisted_302), [
                                                      [_vModelText, t.table_pmi]
                                                    ])
                                                  ])
                                                ]))
                                              }), 256))
                                            ])
                                          ]),
                                          _createElementVNode("table", _hoisted_303, [
                                            _hoisted_304,
                                            _createElementVNode("tbody", null, [
                                              _createElementVNode("tr", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[5].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("td", null, [
                                                    _withDirectives(_createElementVNode("textarea", {
                                                      name: "",
                                                      id: "",
                                                      cols: "30",
                                                      rows: "5",
                                                      "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                    }, null, 8, _hoisted_305), [
                                                      [_vModelText, t.table_comments]
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_306, [
                                        _createElementVNode("div", _hoisted_307, [
                                          _createElementVNode("div", _hoisted_308, [
                                            _createElementVNode("table", _hoisted_309, [
                                              _hoisted_310,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[6].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_311, [
                                                    _createElementVNode("td", _hoisted_312, _toDisplayString(t.table_name), 1),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_313, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "number",
                                                          "onUpdate:modelValue": ($event: any) => ((t.table_backend_ratio) = $event)
                                                        }, null, 8, _hoisted_314), [
                                                          [_vModelText, t.table_backend_ratio]
                                                        ]),
                                                        _hoisted_315
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ]),
                                            (_ctx.$route.query.table != 'foreign' || _ctx.$route.query.table)
                                              ? (_openBlock(), _createElementBlock("table", _hoisted_316, [
                                                  _hoisted_317,
                                                  (tabletype.tables && tabletype.tables[10])
                                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_318, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[10].data, (t) => {
                                                          return (_openBlock(), _createElementBlock("tr", _hoisted_319, [
                                                            _createElementVNode("td", _hoisted_320, [
                                                              _createElementVNode("div", null, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                  type: "text",
                                                                  "onUpdate:modelValue": ($event: any) => ((t.table_text) = $event)
                                                                }, null, 8, _hoisted_321), [
                                                                  [_vModelText, t.table_text]
                                                                ])
                                                              ])
                                                            ])
                                                          ]))
                                                        }), 256))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_322, [
                                            _createElementVNode("table", _hoisted_323, [
                                              _hoisted_324,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[8].data, (t) => {
                                                  return (_openBlock(), _createElementBlock("tr", _hoisted_325, [
                                                    _createElementVNode("td", _hoisted_326, _toDisplayString(t.table_name), 1),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_327, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          type: "number",
                                                          "onUpdate:modelValue": ($event: any) => ((t.table_input_mla) = $event)
                                                        }, null, 8, _hoisted_328), [
                                                          [_vModelText, t.table_input_mla]
                                                        ])
                                                      ])
                                                    ])
                                                  ]))
                                                }), 256))
                                              ])
                                            ]),
                                            _createElementVNode("table", _hoisted_329, [
                                              _hoisted_330,
                                              _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabletype.tables[9].data, (t) => {
                                                    return (_openBlock(), _createElementBlock("td", null, [
                                                      _withDirectives(_createElementVNode("textarea", {
                                                        name: "",
                                                        id: "",
                                                        cols: "30",
                                                        rows: "5",
                                                        "onUpdate:modelValue": ($event: any) => ((t.table_comments) = $event)
                                                      }, null, 8, _hoisted_331), [
                                                        [_vModelText, t.table_comments]
                                                      ])
                                                    ]))
                                                  }), 256))
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 256))
                  ]),
                  _createElementVNode("div", _hoisted_332, [
                    _createElementVNode("button", {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      class: "btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addMLOManually()))
                    }, "Save changes")
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_333, [
              _createElementVNode("table", _hoisted_334, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", {
                      class: "tw-bg-[#00a0da] tw-rounded-tl-2xl tw-rounded-tr-2xl",
                      colspan: _ctx.listUserSections.length + 1
                    }, _hoisted_337, 8, _hoisted_335)
                  ])
                ]),
                (_ctx.listUserSections.length > 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_338, [
                      _createElementVNode("tr", _hoisted_339, [
                        _hoisted_340,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_341, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_342, _toDisplayString(user.username +
                                                " " + user.lastname), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_343, [
                        _hoisted_344,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_345, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_346, _toDisplayString(user.phonenumber), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_347, [
                        _hoisted_348,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_349, [
                            (_ctx.filters.active)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_350, _toDisplayString(user.email), 1))
                              : _createCommentVNode("", true)
                          ]))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_351, [
                        _createElementVNode("td", _hoisted_352, _toDisplayString(_ctx.filters.program_name), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_353, _toDisplayString(user.fha), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_354, [
                        _hoisted_355,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_356, _toDisplayString(user.interes_rate), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_357, [
                        _hoisted_358,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_359, _toDisplayString(user.minimum_down_payment &&
                                            user.minimum_down_payment != "-" ? user.minimum_down_payment + "%" : "-"), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_360, [
                        _hoisted_361,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_362, _toDisplayString(user.average_mip_pmi), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_363, [
                        _hoisted_364,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_365, _toDisplayString(user.backend_ratio), 1))
                        }), 256))
                      ]),
                      _createElementVNode("tr", _hoisted_366, [
                        _hoisted_367,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                          return (_openBlock(), _createElementBlock("td", _hoisted_368, _toDisplayString(user.maximum_loan ? ('' + _ctx.commaFormat(user.maximum_loan)) : ''), 1))
                        }), 256))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("table", _hoisted_369, [
                _createElementVNode("tr", _hoisted_370, [
                  _hoisted_371,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listUserSections, (user) => {
                    return (_openBlock(), _createElementBlock("td", _hoisted_372, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.loadData(user)),
                        class: "tw-bg-[#00a0da] tw-px-11 tw-text-white tw-text-base tw-font-semibold tw-rounded-full tw-py-1 tw-mt-5"
                      }, "GET IT", 8, _hoisted_373)
                    ]))
                  }), 256))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_374, [
          _hoisted_375,
          _createElementVNode("div", _hoisted_376, [
            _hoisted_377,
            _createElementVNode("div", _hoisted_378, [
              _createElementVNode("div", _hoisted_379, [
                _hoisted_380,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.customer.name) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_381, [
                _hoisted_382,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.customer.phone) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.phone]
                ])
              ]),
              _createElementVNode("div", _hoisted_383, [
                _hoisted_384,
                _withDirectives(_createElementVNode("input", {
                  name: "",
                  id: "",
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.customer.email) = $event)),
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5"
                }, null, 512), [
                  [_vModelText, _ctx.customer.email]
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_385, [
          _hoisted_386,
          _createElementVNode("div", _hoisted_387, [
            _createElementVNode("table", _hoisted_388, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_389, [
                  _hoisted_390,
                  _createElementVNode("td", _hoisted_391, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "propertyPrice",
                      value: _ctx.financialInformation.propertyPrice,
                      "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.financialInformation.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_392, [
                  _hoisted_393,
                  _createElementVNode("td", _hoisted_394, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "downPayment",
                      value: _ctx.financialInformation.downPayment,
                      "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.financialInformation.downPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_395, [
                  _hoisted_396,
                  _createElementVNode("td", _hoisted_397, [
                    _createVNode(_component_VueNumberFormat, {
                      id: "loanAmount",
                      value: _ctx.financialInformation.loanAmount,
                      "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.financialInformation.loanAmount) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_398, [
          _hoisted_399,
          _createElementVNode("div", _hoisted_400, [
            _createElementVNode("table", _hoisted_401, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_402, [
                  _hoisted_403,
                  _createElementVNode("td", _hoisted_404, _toDisplayString(_ctx.selection.selectedUser ? _ctx.selection.selectedUser.interes_rate : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_405, [
                  _hoisted_406,
                  _createElementVNode("td", _hoisted_407, _toDisplayString(_ctx.selection.selectedYears ? _ctx.selection.selectedYears.name : ''), 1)
                ]),
                _createElementVNode("tr", _hoisted_408, [
                  _hoisted_409,
                  _createElementVNode("td", _hoisted_410, " $ " + _toDisplayString(_ctx.pmi !== null ? Math.round(_ctx.pmi).toLocaleString() : ''), 1)
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_411, [
          _createElementVNode("button", {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.submitFormula('propertyTotalExample', $event))),
            class: "tw-bg-[#00a0da] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl disabled:tw-bg-[#cfcfcf] disabled:tw-text-white"
          }, "DONE")
        ]),
        _createElementVNode("div", _hoisted_412, [
          _createElementVNode("div", _hoisted_413, [
            _createElementVNode("div", _hoisted_414, [
              _createElementVNode("div", _hoisted_415, [
                _hoisted_416,
                _createVNode(_component_VueNumberFormat, {
                  id: "propertyPrice",
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3",
                  disabled: "",
                  value: _ctx.financialInformation.totalMonthly,
                  "onUpdate:value": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.financialInformation.totalMonthly) = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_417, [
          _createElementVNode("button", {
            onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitScenario($event))),
            disabled: !_ctx.scenarioValid,
            class: "tw-bg-[#78c18a] disabled:tw-bg-[#ccc] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER", 8, _hoisted_418)
        ])
      ])
    ])
  ]))
}